// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Coinbetting B2C palette — black surfaces + golden yellow accents.
  RGB triplets so Tailwind colors can use /alpha: rgb(var(--token) / <alpha-value>)
*/
:root,
body.prediction-market-open,
.prediction-market-page {
  --color-surface: 30 30 30; /* #1E1E1E */
  --color-surface-raised: 46 46 46; /* #2E2E2E */
  --color-surface-muted: 53 53 53; /* #353535 */
  --color-surface-overlay: 42 42 42;
  --color-ink: 255 255 255;
  --color-ink-soft: 231 231 231; /* #E7E7E7 */
  --color-ink-muted: 150 150 150; /* #969696 */
  --color-ink-faint: 107 117 139; /* #6B758B */
  --color-ink-inverse: 0 0 0;
  --color-line: 53 53 53;
  --color-line-strong: 203 125 0; /* #CB7D00 */
  --color-border-card: 53 53 53;
  --color-accent: 239 212 60; /* #EFD43C */
  --color-accent-soft: 64 48 8;
  --color-accent-contrast: 0 0 0;
  --color-success: 114 242 56; /* #72F238 */
  --color-success-soft: 22 48 12;
  --color-success-contrast: 180 255 140;
  --color-danger: 255 73 73; /* #FF4949 */
  --color-danger-soft: 64 16 16;
  --color-danger-contrast: 254 202 202;
  --color-warning: 255 176 24; /* #FFB018 */
  --color-warning-soft: 64 40 8;
  --color-warning-contrast: 254 236 180;
  --color-info: 239 212 60;
  --color-info-soft: 56 44 8;
  --color-info-contrast: 239 212 60;
  --color-shadow: 0 0 0;
  --pm-gold: 239 212 60;
  --pm-gold-dark: 203 125 0;
  --pm-gold-bright: 252 212 67; /* #FCD443 */
  --color-background: 0 0 0; /* #000000 */
  --pm-felt: 203 125 0;
  --pm-radius: 8px;
  --pm-radius-sm: 6px;
  --pm-radius-lg: 10px;
}

.prediction-market-page {
  color-scheme: dark;
}

.prediction-market-page .border-line-card {
  border-width: 1px;
  border-style: solid;
}
`, "",{"version":3,"sources":["webpack://./src/styles/prediction-market-theme.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;;;EAGE,yBAAyB,EAAE,YAAY;EACvC,gCAAgC,EAAE,YAAY;EAC9C,+BAA+B,EAAE,YAAY;EAC7C,iCAAiC;EACjC,wBAAwB;EACxB,6BAA6B,EAAE,YAAY;EAC3C,8BAA8B,EAAE,YAAY;EAC5C,8BAA8B,EAAE,YAAY;EAC5C,0BAA0B;EAC1B,sBAAsB;EACtB,8BAA8B,EAAE,YAAY;EAC5C,6BAA6B;EAC7B,0BAA0B,EAAE,YAAY;EACxC,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B,EAAE,YAAY;EACzC,8BAA8B;EAC9B,qCAAqC;EACrC,yBAAyB,EAAE,YAAY;EACvC,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B,EAAE,YAAY;EACzC,6BAA6B;EAC7B,qCAAqC;EACrC,wBAAwB;EACxB,0BAA0B;EAC1B,iCAAiC;EACjC,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B,EAAE,YAAY;EAC1C,yBAAyB,EAAE,YAAY;EACvC,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":["/*\n  Coinbetting B2C palette — black surfaces + golden yellow accents.\n  RGB triplets so Tailwind colors can use /alpha: rgb(var(--token) / <alpha-value>)\n*/\n:root,\nbody.prediction-market-open,\n.prediction-market-page {\n  --color-surface: 30 30 30; /* #1E1E1E */\n  --color-surface-raised: 46 46 46; /* #2E2E2E */\n  --color-surface-muted: 53 53 53; /* #353535 */\n  --color-surface-overlay: 42 42 42;\n  --color-ink: 255 255 255;\n  --color-ink-soft: 231 231 231; /* #E7E7E7 */\n  --color-ink-muted: 150 150 150; /* #969696 */\n  --color-ink-faint: 107 117 139; /* #6B758B */\n  --color-ink-inverse: 0 0 0;\n  --color-line: 53 53 53;\n  --color-line-strong: 203 125 0; /* #CB7D00 */\n  --color-border-card: 53 53 53;\n  --color-accent: 239 212 60; /* #EFD43C */\n  --color-accent-soft: 64 48 8;\n  --color-accent-contrast: 0 0 0;\n  --color-success: 114 242 56; /* #72F238 */\n  --color-success-soft: 22 48 12;\n  --color-success-contrast: 180 255 140;\n  --color-danger: 255 73 73; /* #FF4949 */\n  --color-danger-soft: 64 16 16;\n  --color-danger-contrast: 254 202 202;\n  --color-warning: 255 176 24; /* #FFB018 */\n  --color-warning-soft: 64 40 8;\n  --color-warning-contrast: 254 236 180;\n  --color-info: 239 212 60;\n  --color-info-soft: 56 44 8;\n  --color-info-contrast: 239 212 60;\n  --color-shadow: 0 0 0;\n  --pm-gold: 239 212 60;\n  --pm-gold-dark: 203 125 0;\n  --pm-gold-bright: 252 212 67; /* #FCD443 */\n  --color-background: 0 0 0; /* #000000 */\n  --pm-felt: 203 125 0;\n  --pm-radius: 8px;\n  --pm-radius-sm: 6px;\n  --pm-radius-lg: 10px;\n}\n\n.prediction-market-page {\n  color-scheme: dark;\n}\n\n.prediction-market-page .border-line-card {\n  border-width: 1px;\n  border-style: solid;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
